import React, { useEffect } from 'react';
import { installMetaPixel } from './utils/metaPixel';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { WhatWeDo } from './components/WhatWeDo';
import { Products } from './components/Products';
import { Benefits } from './components/Benefits';
import { WhyUs } from './components/WhyUs';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { Philosophy } from './components/Philosophy';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    installMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-[#0d0d0f] font-sans antialiased selection:bg-violet-500/30" data-id="element-0" data-mp="31bianp7oiogh">
      <Header data-id="element-1" data-mp="2wiffxdr618yp" />
      <main data-id="element-2" data-mp="2whx9joashed2">
        <Hero data-id="element-3" data-mp="2wi5l9cv6edmo" />
        <WhatWeDo data-id="element-4" data-mp="28u5x8kp911bs" />
        <Products data-id="element-5" data-mp="28tmg367fagyt" />
        <Benefits data-id="element-6" data-mp="28t4kmbsl46ry" />
        <WhyUs data-id="element-7" data-mp="28sl511qepuh3" />
        <Testimonials data-id="element-8" data-mp="28s2xh8yanttv" />
        <CTA data-id="element-9" data-mp="23vkzqt1dsvr1" />
        <Philosophy data-id="element-10" data-mp="23w4e5zrtp20b" />
      </main>
      <Footer data-id="element-11" data-mp="23ut9lxqjzq85" />
    </div>;
}